import { TJSStyleManager } from '@typhonjs-fvtt/runtime/util/dom/style';

export const cssVariables = new TJSStyleManager({ docKey: '#__trl-root-styles', version: 1 });
